import React from 'react'
import { FilterOption } from '../../components/_WMS/FilterComponent'
import { GenericFilter } from './components/GenericFilter'

const createBooleanBackendTransformer = (rawValue: string): string => rawValue

const createBooleanDisplayTransformer = (rawValue: string): string => {
  if (rawValue === 'true') return 'Sí'
  if (rawValue === 'false') return 'No'
  return rawValue
}


export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'sku',
    label: 'SKU',
    type: 'text'
  },
  {
    order: 2,
    key: 'ean13',
    label: 'EAN13',
    type: 'text'
  },
  {
    order: 3,
    key: 'Erpcode',
    label: 'Codigo ERP',
    type: 'text'
  },
  {
    order: 4,
    key: 'productOriginId',
    label: 'Marca',
    type: 'precreated'
  },
  {
    order: 6,
    key: 'isGreenSale',
    label: 'Venta en Verde',
    type: 'precreated'
  }, 
  {
    order: 7,
    key: 'active',
    label: 'Activo',
    type: 'precreated'
  },
  {
    order: 8,
    key: 'externalStorage',
    label: 'Almacenamiento externo',
    type: 'custom',
    Component: (props: any) => React.createElement(GenericFilter, { ...props, fieldName: 'active' }),
    transformForBackend: createBooleanBackendTransformer,
    transformForDisplay: createBooleanDisplayTransformer
  },
  {
    order: 9,
    key: 'expirationDate',
    label: 'Control de fecha de vencimiento',
    type: 'custom',
    Component: (props: any) => React.createElement(GenericFilter, { ...props, fieldName: 'expirationDate' }),
    transformForBackend: createBooleanBackendTransformer,
    transformForDisplay: createBooleanDisplayTransformer
  },
  {
    order: 10,
    key: 'batch',
    label: 'Control de Lote',
    type: 'custom',
    Component: (props: any) => React.createElement(GenericFilter, { ...props, fieldName: 'batch' }),
    transformForBackend: createBooleanBackendTransformer,
    transformForDisplay: createBooleanDisplayTransformer
  },
  {
    order: 11,
    key: 'dun',
    label: 'DUN',
    type: 'text'
  },
]

export const defaultFilters = []
